import { AiChatState } from "@intelligems/ig-types";
import { aiApiClient } from "@src/api/ai-api";
import { useQuery } from "@tanstack/react-query";

interface UseGetChatHistoryOptions {
  sessionId: string | null;
  isAdmin?: boolean;
  enabled?: boolean;
}

export const useGetChatHistory = ({
  sessionId,
  isAdmin = false,
  enabled = true,
}: UseGetChatHistoryOptions) => {
  return useQuery({
    queryKey: ["chat-history", sessionId, isAdmin ? "admin" : "user"],
    queryFn: async () => {
      if (!sessionId) {
        throw new Error("Session ID is required");
      }

      const endpoint = isAdmin
        ? `/chat-history/admin/session/${sessionId}`
        : `/chat-history/session/${sessionId}`;

      const response = await aiApiClient.get<{
        chat: AiChatState | null;
      } | null>(endpoint);

      return response.data;
    },
    enabled: enabled && !!sessionId,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
